const ARABIC_INDIC = '٠١٢٣٤٥٦٧٨٩'
const PERSIAN = '۰۱۲۳۴۵۶۷۸۹'

/** Turns Arabic-Indic and Persian digits into 0-9. */
export const normalizeDigits = (value: string): string =>
    value
        .replace(/[٠-٩]/g, digit => String(ARABIC_INDIC.indexOf(digit)))
        .replace(/[۰-۹]/g, digit => String(PERSIAN.indexOf(digit)))

/** Returns an Egyptian mobile number as 01XXXXXXXXX, or null when it is not valid. */
export const normalizeEgyptMobile = (input: string): string | null => {
    let digits = normalizeDigits(input).replace(/[^\d+]/g, '')

    if (digits.startsWith('+20')) digits = `0${digits.slice(3)}`
    else if (digits.startsWith('0020')) digits = `0${digits.slice(4)}`
    else if (digits.startsWith('20') && digits.length === 12) digits = `0${digits.slice(2)}`

    digits = digits.replace(/\D/g, '')

    return /^01[0125]\d{8}$/.test(digits) ? digits : null
}

/** International digits without the plus sign, as wa.me expects. */
export const toWhatsAppNumber = (input: string): string => {
    const digits = normalizeDigits(input).replace(/\D/g, '')

    if (digits.startsWith('00')) return digits.slice(2)
    if (digits.startsWith('20')) return digits
    if (digits.startsWith('0')) return `20${digits.slice(1)}`

    return digits
}

export const whatsappLink = (number: string, text?: string): string => {
    const target = toWhatsAppNumber(number)
    const query = text ? `?text=${encodeURIComponent(text)}` : ''

    return `https://wa.me/${target}${query}`
}

export const telLink = (number: string): string => `tel:${normalizeDigits(number).replace(/[^\d+]/g, '')}`
